export const areaList = {
    // 显示朝阳区
    // province_list: {
    //     110000: '朝阳区'
    // },
    // 显示街道
    province_list: {
        110000: '朝外街道',
        120000: '建外街道',
        130000: '左家庄街道',
        140000: '六里屯街道',
        150000: '八里庄街道',
        160000: '三里屯街道',
        170000: '呼家楼街道',
        180000: '团结湖街道',
        190000: '麦子店街道',
        200000: '酒仙桥街道',
        210000: '香河园街道',
        220000: '潘家园街道',
        230000: '亚运村街道',
        240000: '和平街街道',
        250000: '双井街道',
        260000: '小关街道',
        270000: '垡头街道',
        280000: '劲松街道',
        290000: '安贞街道',
        300000: '机场街道',
        310000: '望京街道',
        320000: '大屯街道',
        330000: '奥运村街道',
        340000: '东湖街道',
        350000: '来广营地区',
        360000: '太阳宫地区',
        370000: '将台地区',
        380000: '金盏地区',
        390000: '东坝地区',
        400000: '平房地区',
        410000: '高碑店地区',
        420000: '南磨房地区',
        430000: '王四营地区',
        440000: '十八里店地区',
        450000: '小红门地区',
        460000: '东风地区',
        470000: '黑庄户地区',
        480000: '三间房地区',
        490000: '常营地区',
        500000: '豆各庄地区',
        510000: '管庄地区',
        520000: '崔各庄地区',
        530000: '孙河地区',
    }
}